import Routes from './routes';

/**
 * Central route -> page-name map.  RouteTitle.js walks this list in order on
 * every navigation and sets `document.title` to "<title> | Pacer" for the first
 * match, so titles stay correct even when a page is reached by an in-place
 * navigation (drill-down, applying a saved view) that does not remount the page.
 *
 * ORDER MATTERS: more specific paths must come before the generic paths that
 * would otherwise match them (e.g. /tasks/manage-views before /tasks). Keep this
 * roughly aligned with the <Switch> in App.js. Data-driven titles (report name,
 * PCH project name) are refined by the page itself via setDocumentTitle().
 */
export const routeTitles = [
	{ path: Routes.LoginPage, title: 'Login' },
	{ path: Routes.LogoutPage, title: 'Logout' },
	{ path: Routes.ForgotUserName, title: 'Forgot Username' },
	{ path: Routes.ForgotPassword, title: 'Forgot Password' },
	{ path: Routes.ResetPassword, title: 'Reset Password' },
	{ path: Routes.SignUp, title: 'Sign Up' },
	{ path: Routes.StyleGuide, title: 'Style Guide' },
	{ path: Routes.SsoErrorPage, title: 'SSO Error' },
	{ path: Routes.External.TaskCompletion, title: 'Task Completion' },
	{ path: Routes.FreeTrialSignUp, title: 'Free Trial Sign Up' },

	{ path: Routes.ProfileNotifications, title: 'Notification Settings' },
	{ path: Routes.ProfileUser, title: 'My Profile' },
	{ path: Routes.DashboardCorporate, title: 'Company Overview' },
	{ path: Routes.Overview, title: 'Portfolio' },
	{ path: Routes.Admin + '/project/:projectKey/project-locations', exact: true, title: 'Project Locations' },

	// /dashboard/location/financials-spreadsheet must precede /dashboard/location
	{ path: Routes.DashboardLocationFinancials, exact: true, title: 'Location Financials' },
	{ path: Routes.DashboardLocation, exact: true, title: 'Dashboard' },
	{ path: Routes.ManageCorporateViews, title: 'Manage Corporate Views' },

	// /tasks/manage-views must precede /tasks
	{ path: Routes.ManageTaskViews, title: 'Manage Task Views' },
	{ path: Routes.Tasks, title: 'Task List' },

	// specific admin sections (rendered inside SubscriptionAdminPage) before the generic /admin/home
	{ path: Routes.AdminHome + '/subscription_profile', title: 'Subscription Profile' },
	{ path: Routes.AdminHome, title: 'Admin' },

	{ path: Routes.ScheduleReport, title: 'Schedule Report' },
	{ path: Routes.Reports, exact: true, title: 'Reports' },
	{ path: Routes.Reports + '/:reportId', title: 'Report' },

	{ path: Routes.BaselineTaskList, title: 'Baseline Task List' },
	{ path: Routes.ProjectManagerDashboard, title: 'Project Dashboard' },
	{ path: Routes.NewProjectManagerDashboard, title: 'Project Control Hub' },

	{ path: Routes.DashboardEhAdmin, title: 'Admin Dashboard' },
	{ path: '/subscription/:subscriptionId/locations', exact: true, title: 'Locations' },
	{ path: '/subscription/config/:subscriptionId?', title: 'Subscription Config' },
	{ path: Routes.CrossSubscriptionSearch, title: 'Cross Subscription Search' },
	{ path: '/subscription/users/:subscriptionId?', title: 'Subscription Users' },
	{ path: Routes.ToolTips, title: 'Tooltips' },
	{ path: Routes.WebAssets, title: 'Web Assets' },
	{ path: '/subscription/:subscriptionId?', title: 'Subscription' },

	{ path: Routes.CrossBaselineSearch, title: 'Cross Baseline Search' },
	{ path: Routes.CrossBaselineTaskLinkSearch, title: 'Cross Baseline Task Link Search' },
	{ path: Routes.MyWorkspace, title: 'My Workspace' },
	{ path: Routes.NewProjectWizard, title: 'New Project' },
	{ path: Routes.PchNotYet, title: 'Project Control Hub' },
	{ path: Routes.Forbidden, title: 'Forbidden' },
];

export default routeTitles;
